import { render, staticRenderFns } from "./PlanGameTemplate.vue?vue&type=template&id=01880078&"
import script from "./PlanGameTemplate.vue?vue&type=script&lang=js&"
export * from "./PlanGameTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PlanGameTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports